import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import DropDownSelector from 'components/DropDownSelector';

import './styles.scss';

const getYearsOptions = () => new Array(150).fill(0).reduce((acc, val, idx) => {
    const next = acc[idx].title - 1;
    acc.push({ value: `${ next }`, title: next });
    return acc;
}, [ { value: `${ new Date().getUTCFullYear() }`, title: new Date().getUTCFullYear() } ]);

const getMonthsOptions = (translateObject) => new Array(12).fill(0).map((val, idx) => {
    return { value: `${ idx + 1 }`, title: `${ translateObject.t(`motivator.month_${ idx + 1 }`) }` };
});

const CompanyDateQuestion = ({ updateAnswers, joinYear, joinMonth }) => {
    return (
        <React.Fragment>
            <div className='options-container'>
                <div className='placeholder' />
                <div className='input-options'>
                    <DropDownSelector
                        selected={ joinYear.value ? joinYear : { value: null, title: i18n.t('motivator.year') } }
                        options={ getYearsOptions() }
                        callBack={ (option) => updateAnswers('joinYear', option) } />
                    <DropDownSelector
                        selected={ joinMonth.value ? joinMonth : { value: null, title: i18n.t('motivator.month') } }
                        options={ getMonthsOptions(i18n) }
                        callBack={ (option) => updateAnswers('joinMonth', option) } />
                </div>
                <span
                    className={ `prefer-not-to-say ${ joinYear.value === null && joinMonth.value === null ? 'selected' : '' }` }
                    onClick={ () => {
                        updateAnswers('joinYear', { value: null, title: null });
                        updateAnswers('joinMonth', { value: null, title: null });
                    } }>
                    {i18n.t('motivator.prefer_not_to_say')}
                </span>
            </div>
        </React.Fragment>
    );
};

CompanyDateQuestion.defaultProps = {
    updateAnswers: null,
    joinYear: {},
    joinMonth: {}
};

CompanyDateQuestion.propTypes = {
    updateAnswers: PropTypes.func,
    joinYear: PropTypes.object,
    joinMonth: PropTypes.object
};

export default CompanyDateQuestion;
